export class TextLoader {
    url: string;
    param: object;
    body: string;
    useCookie: boolean;
    credentials: string;
    timeout: number = 10000;
    constructor(url?: string, param?: object) {
        this.url = url;
        this.param = param;
    }
    setURL = (url: string): void => {
        this.url = url;
    }
    setParam = (param: object): void => {
        this.param = param;
    }
    setUseCookie = (flag: boolean): void => {
        this.useCookie = flag;
    }
    load = (): Promise<string> => {


        //   console.log(this.url);
        if (this.param) {
            this.body = Object.keys(this.param).map((key) => key + "=" + encodeURIComponent(this.param[key])).join("&");
        }

        let options = {};
        if (this.useCookie) {
            options = {
                body: this.body,
                cache: <RequestCache>'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: <RequestCredentials>'include', // include, same-origin, *omit
                headers: {
                    'Accept': 'text/html',
                },
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: <RequestMode>'cors', // no-cors, cors, *same-origin
                redirect: <RequestRedirect>'follow', // manual, *follow, error
                //referrer: 'no-referrer', // *client, no-referrer
            }
        } else {
            options = {
                body: this.body,
                cache: <RequestCache>'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                headers: {
                    'Accept': 'text/html',
                },
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                redirect: <RequestRedirect>'follow', // manual, *follow, error
            }
        }
        const loadFunc = new Promise((resolve, reject) => {
            fetch(this.url, options).then(response => {
                //console.log(response)
                return response.text();
            }).then(text => {
                resolve(text);
            }).catch(reason => {
                reject(reason);
            })
        });

        const timeoutFunc = new Promise((_resolve, reject) => {
            setTimeout(() => reject('[TextLoader]Timed out in ' + this.timeout + 'ms.'), this.timeout);
        });

        return new Promise((resolve, reject) => {
            Promise.race([
                loadFunc,
                timeoutFunc
            ]).then(value => {
                resolve(<string>value);
            }).catch(reason => {
                reject(reason);
            })
        });
    }
}
